// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qrcode_popover":"qrcode_popover_h8vRK","ui_mask":"ui_mask_svrA1"};